import React from 'react';
import Work from '../../components/work/Work';

function WorkPage() {
    return (
        <>
            <Work />
        </>
    );
}

export default WorkPage;
